import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Calendar, MapPin, Search } from "lucide-react";
import { format } from "date-fns";
import { cn } from "@/lib/utils";
import type { EventRow } from "@/hooks/events/useEvents";

interface Props {
  events: EventRow[];
  selectedId: string | null;
  onSelect: (id: string) => void;
  search: string;
  onSearchChange: (v: string) => void;
  isLoading?: boolean;
}

export const EventList = ({ events, selectedId, onSelect, search, onSearchChange, isLoading }: Props) => {
  return (
    <div className="flex flex-col h-full border rounded-lg bg-card">
      <div className="p-3 border-b">
        <div className="relative">
          <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="ค้นหา event..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-8"
          />
        </div>
      </div>
      <ScrollArea className="flex-1">
        <div className="p-2 space-y-2">
          {isLoading && <div className="text-sm text-muted-foreground p-3">กำลังโหลด...</div>}
          {!isLoading && events.length === 0 && (
            <div className="text-sm text-muted-foreground p-3">ไม่พบ event</div>
          )}
          {events.map((e) => (
            <button
              key={e.id}
              onClick={() => onSelect(e.id)}
              className={cn(
                "w-full text-left p-3 rounded-md border transition-colors hover:bg-accent",
                selectedId === e.id && "bg-accent border-primary"
              )}
            >
              <div className="font-medium text-sm">{e.name}</div>
              <div className="text-xs text-muted-foreground mt-1 flex items-center gap-1">
                <Calendar className="h-3 w-3" />
                {format(new Date(e.start_at), "d MMM yyyy HH:mm")}
              </div>
              {e.location && (
                <div className="text-xs text-muted-foreground mt-0.5 flex items-center gap-1">
                  <MapPin className="h-3 w-3" />
                  {e.location}
                </div>
              )}
            </button>
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
